<template>
    <div class="wrapper">
        <div class="left">
            <header class="header border">
                <div class="header-element">
                    <img :src="companyLogo" alt="logo" 
                        style="cursor: pointer;" @click="toggleSideNav"/>
                    <h3>WELL OPERATIONS DASHBOARD</h3>
                </div>
                <b-button class="text-right header-btn" variant="primary" @click="showListOfOperationsModal = true">
                    List of operations
                </b-button>
                <b-modal v-model="showListOfOperationsModal" size="xl" title="List of Operations" hide-footer>
                    <div class="table">
                        <b-spinner 
                          v-if="isLoading"
                          style="position: absolute; inset: 0; display: flex; align-self: center; justify-self: center; z-index: 10;"
                          label="Loading..."></b-spinner>
                        <b-table striped hover :items="listOfOperations" :fields="listOfOperationsfields">
                          <template v-slot:cell(serial)="data">
                            {{ data.index + 1 }}
                          </template>
                            <template v-slot:cell(status)="data">
                                <span style="border-radius: 4px; padding-inline: 0.5rem; padding-block: 0.25rem; font-size: 14px;" :style="{
                                    backgroundColor: data.item.status.toLowerCase() === 'ongoing' ? '#FFC107' : (data.item.status.toLowerCase() === 'completed' ? '#2eaa3e' : (data.item.status.toLowerCase() === 'n/a' ? 'transparent' : (data.item.status.toLowerCase() === 'suspended' ? '#d793d7' : '#DC3545'))),
                                    color: data.item.status.toLowerCase() === 'n/a' ? 'black': 'white'
                                }">{{data.item.status}}</span>
                            </template>
                            <template v-slot:cell(current_phase)="data">
                                {{ getCurrentPhase(data.item.projectId) }}
                            </template>
                        </b-table>
                    </div>
                    <b-button variant="secondary" block
                        @click="showListOfOperationsModal = false">Close</b-button>
                </b-modal>
            </header>

            <div class="left-content-wrapper">
                <div class="left-content-initial">
                    <div class="objective-container border">
                        <h4>Objective</h4>
                        <div class="objective-container-text" style="max-height: 50px; overflow-y: auto; font-size: .92rem; padding-bottom: 0.25rem;">
                            {{ project && project.objective != '' ? project.objective : 'N/A' }}
                        </div>
                    </div>

                    <div class="well-info border">
                        <span class="left-span"></span>
                        <div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">
                                            {{ project && project.well ? project.well.wellType : 'N/A' }}
                                        </h5>
                                        <p style="margin-bottom: 0px">Well type</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">
                                            {{ project && project.rig ? project.rig.terrain : 'N/A' }}
                                        </h5>
                                        <p style="margin-bottom: 0px">Location</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">
                                            {{ project && project.rig ? project.rig.name : 'N/A' }}
                                        </h5>
                                        <p style="margin-bottom: 0px">Rig</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ dailyReportsByProject.length ?
                                            dailyReportsByProject[0].schedule.spudDate || 'N/A' : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Spud/Re-entry Date</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ (this.project) ?
                                            hideRigMove ? Number(computeDuration(this.project.start,
                                            this.project.end)) - RigMovePlanDays : Number(computeDuration(this.project.start,
                                                this.project.end)) : 0 }}</h5>
                                        <p style="margin-bottom: 0px">Planned (Days)</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ hideRigMove ? actualDays - RigMoveAcualDays : actualDays }}</h5>
                                        <p style="margin-bottom: 0px">Actual (Days)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="well-info border">
                        <span class="left-span"></span>
                        <div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ this.project && this.project.rig &&
                                            this.project.rig.rigContract ?
                                            this.project.rig.rigContract.rigContractType : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Rig Contract Type</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ dailyReportsByProject.length ?
                                            dailyReportsByProject[dailyReportsByProject.length -
                                                1].depthSummary.currentHoleSize : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Current hole section (in)</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ this.project && this.project.well &&
                                            this.project.well.totalDepthMD ?
                                            this.project.well.totalDepthMD.value : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Target Depth (ft-MD)</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ dailyReportsByProject.length ?
                                            `${dailyReportsByProject[dailyReportsByProject.length -
                                                1].depthSummary.casingSize}/${dailyReportsByProject[dailyReportsByProject.length
                                                    - 1].depthSummary.casingDepth}` : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">
                                            Last Casing Size/Depth ("/ft-MD)
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; flex: 1">
                                <div style="flex: 1">
                                    <h5 style="margin-bottom: 0px">{{ project && dailyReportsByProject.length &&
                                        isFinite(Number(percentage(getPlanBudgetForProject, afeCummulativeCost))) ?
                                        percentage(getPlanBudgetForProject, afeCummulativeCost).toFixed(2) : 'N/A' }}
                                    </h5>
                                    <p style="margin-bottom: 0px">% Spend</p>
                                </div>
                                <div style="flex: 1">
                                    <h5 style="margin-bottom: 0px">{{ dailyReportsByProject.length ?
                                        dailyReportsByProject[dailyReportsByProject.length -
                                            1].depthSummary.currentDepth : 'N/A' }}</h5>
                                    <p style="margin-bottom: 0px">Current Well Depth (ft-MD)</p>
                                </div>
                            </div>
                            <div>
                                <div style="display: flex; flex: 1">
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ project ?
                                            getPlanBudgetForProject : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Planned AFE (K$)</p>
                                    </div>
                                    <div style="flex: 1">
                                        <h5 style="margin-bottom: 0px">{{ dailyReportsByProject.length ?
                                            Number(afeCummulativeCost).toFixed(2) : 'N/A' }}</h5>
                                        <p style="margin-bottom: 0px">Actual Spend (K$)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="current-activity-container border">
                        <h4>Current Activity</h4>
                        <div class="objective-container-text" style="max-height: 50px; overflow-y: auto; font-size: .92rem; padding-bottom: 0.25rem;">
                            {{ dailyReportsByProject.length &&
                                dailyReportsByProject[dailyReportsByProject.length - 1].dailySummary !== '' ?
                                dailyReportsByProject[dailyReportsByProject.length - 1].dailySummary : 'N/A' }}
                        </div>
                    </div>
                </div>
                <div class="left-content-end">
                    <div class="incremental-prod border">
                        <div class="npt-text">                            
                            <b-form-checkbox v-model="hideRigMove">Hide Rig Move</b-form-checkbox>
                        </div>
                        <div class="npt-btn" style="display: flex; gap: 0.5rem; align-items: center;">
                            <div class="npt-h4" style="font-weight: 700;">NPT: </div>
                            <div class="npt-p" v-if="getNPTHoursPercent" style="padding: .2rem;
                              background-color: green;
                              color: #fff;
                              border-radius: 5px;
                              font-weight: 900;">{{ percentage(Number(actualNPTDays), getNPTHoursPercent).toFixed(1) }}%</div>
                        </div>                                                
                    </div>
                    <div class="duration border">
                        <div style="display: flex; 
                            align-items: center;
                            height: 40px;"
                            class="icon-div">
                            <icon class="icon mr-2" :icon="duration()"></icon>
                            <div style="width: 100%;
                              display: flex; 
                              justify-content: space-between; 
                              align-items: center;">
                                <div><strong>Duration (days)</strong></div>                                
                            </div>
                        </div>
                        <div class="duration-doughnut" style="position: relative; padding: 0px;">
                            <component :is="'doughnut-chart'" class="doughnut-chart" style="height: 200px; margin-top: 0px;" :options="durationChartOptions"
                                :chartData="durationChartData" :key="refreshChart" />
                            <div v-if="project && (Number(computeDuration(project.start,
                                            project.end)) > 0 || actualDays)" style="position: absolute;
                                bottom: 10%;
                                left: 50%;
                                transform: translateX(-50%);">
                                <h1 style="
                                    line-height: 40px;" :class="Number(actualDays) <= Number((project) ?
                                        computeDuration(project.start,
                                            project.end) : 0) ? 'green-zone' : 'red-zone'">{{ hideRigMove ? Number(actualDays) - RigMoveAcualDays : Number(actualDays) }}</h1>
                                <h3 class="text-center" style="
                                    line-height: 11px;
                                    font-size: 1.5rem;
                                    font-weight: normal;">Plan: {{ Number(project ?
                                        hideRigMove ? Number(computeDuration(project.start,
                                            project.end)) - RigMovePlanDays : Number(computeDuration(project.start,
                                            project.end)) : 0) }}</h3>
                                <h3 class="text-center" style="
                                    line-height: 25px;
                                    font-size: 1.5rem;
                                    font-weight: normal;">({{ durationData().diff }} {{ durationData().percent }})</h3>
                            </div>
                        </div>
                        
                        <div class="text-center" style="font-weight: 600;">
                          NPT / Actual Time (days): {{ (getNPTHoursPercent / 24).toFixed(2) }} / {{ hideRigMove ? Number(actualDays) - RigMoveAcualDays : Number(actualDays) }}
                        </div>
                        <div></div>
                    </div>
                    <div class="afe border">
                        <div style="display: flex; 
                            align-items: center;
                            height: 40px;"
                            class="icon-div">
                            <icon class="icon mr-2" :icon="coin()"></icon>
                            <div>
                                <strong>AFE (USD)</strong>
                            </div>
                        </div>
                        <div class="duration-doughnut" style="position: relative;">
                            <component :is="'doughnut-chart'" class="doughnut-chart" style="height: 200px;" :options="durationChartOptions"
                                :chartData="afeChartData" :key="refreshAFEChart" />
                            <div v-if="project && (getPlanBudgetForProject > 0 || afeCummulativeCost)" style="position: absolute;
                                bottom: 10%;
                                left: 50%;
                                transform: translateX(-50%);">
                                <h1 style="
                                    line-height: 40px;" :class="Number(dailyReportsByProject.length ?
                                        afeCummulativeCost : 0) <= Number(project ?
                                            getPlanBudgetForProject : 0) ? 'green-zone' : 'red-zone'">{{
                                                formatNumber(Number(dailyReportsByProject.length ?
                                                    afeCummulativeCost : 0)) }}</h1>
                                <h3 class="text-center" style="
                                    line-height: 11px;
                                    font-size: 1.5rem;
                                    font-weight: normal;">Plan: {{ formatNumber(Number(project ?
                                        getPlanBudgetForProject : 0)) }}</h3>
                                <h3 class="text-center" style="
                                    line-height: 25px;
                                    font-size: 1.5rem;
                                    font-weight: normal;">({{ afeUSD().diff }} {{ afeUSD().percent }})</h3>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="right">
            <div class="dropdowns-container border">
                <div>
                    <p style="font-size: 12px; margin-bottom: 3px">Select Sequence</p>
                    <b-form-select size="sm" class="select-sequence" @change="sequenceSelectionChanged" :options="sequenceOptions"
                        v-model="selectedSequenceId">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Select Sequence</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>

                <div class="dropdowns">
                    <div>
                        <p style="font-size: 12px; margin-bottom: 3px">Status</p>
                        <b-form-select size="sm" class="select-sequence" 
                            :disabled="isSequenceLoding" :options="statusOptions" v-model="selectedStatus">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Select Status</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <div>
                        <p style="font-size: 12px; margin-bottom: 3px">Asset</p>
                        <b-form-select size="sm" class="select-sequence" 
                            :disabled="isSequenceLoding" :options="assets.map((asset) => ({ text: asset, value: asset }))"
                            v-model="selectedAsset">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Select Asset</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                    <div>
                        <p style="font-size: 12px; margin-bottom: 3px">Well</p>
                        <b-form-select size="sm" class="select-sequence" 
                            :disabled="isSequenceLoding" :options="wells" v-model="selectedWell">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Select Well</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
                <div class="text-right report-date">
                    Report Date: <span class="font-weight-bold">{{ new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) }}</span>
                </div>
            </div>

            <div class="selected-options">
                <div>
                    <h4 class="asset">{{ selectedAsset || "N/A" }}</h4>
                    <h4 class="well">{{ project ? project.well.name : "" || "N/A" }}</h4>
                </div>
                <span :style="statusClass(selectedStatus)">{{ selectedStatus ? selectedStatus.charAt(0).toUpperCase() +
                    selectedStatus.slice(1) : '' }}</span>
            </div>
            <div class="oil-gas-prod-wrapper">
                <div class="oil-gas-prod-container border">
                    <div style="height: 150px;" class="oil-prod-text">
                        <h4 style="height: 40px;">Oil Production<br />(bopd)</h4>
                        <div class="content">
                            <span class="left-span" />
                            <div>
                                <div style="height: 50px;">
                                    <h2>{{ getExpectedOilRate !== 'N/A' ? formatDecimals(Number(getExpectedOilRate)) :
                                        'N/A' }}</h2>
                                    <p>Expected</p>
                                </div>
                                <div class="mt-1" style="height: 50px;">
                                    <h2>{{ getActualOilRate !== 'N/A' ? formatDecimals(Number(getActualOilRate)) : 'N/A'
                                        }}</h2>
                                    <p>Actual</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 150px;" class="oil-prod-text">
                        <h4 style="margin-top: 8px; height: 40px;">Gas Production<br />(mmscfd)</h4>
                        <span class="left-span" />
                        <div class="content">
                            <span class="left-span" />
                            <div>
                                <div style="height: 50px;">
                                    <h2>{{ getExpectedGasRate != 'N/A' ? formatDecimals(Number(getExpectedGasRate)) :
                                        'N/A' }}</h2>
                                    <p>Expected</p>
                                </div>
                                <div class="mt-1" style="height: 50px;">
                                    <h2>{{ getActualGasRate != 'N/A' ? formatDecimals(Number(getActualGasRate)) : 'N/A'
                                        }}</h2>
                                    <p>Actual</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="oil-gas-prod-charts border">
                    <div style="height: 150px;" class="oil-prod-text">
                        <h4 style="width: 50px; height: 40px;">
                            <icon class="icon mr-2" :icon="oilTank()"></icon>
                        </h4>
                        <div class="content">
                            <div class="w-100">
                                <div v-if="getExpectedOilRate !== 'N/A'" style="background-color: #ECD4D4; 
                                    display: flex;
                                    height: 50px;
                                    align-items: center; 
                                    justify-content: flex-end;
                                    padding-right: 8px;
                                    font-weight: bold;
                                    color: #D63E4A;">
                                    <span>{{ Number(getExpectedOilRate) }}</span>
                                </div>
                                <div class="mt-1" v-if="getActualOilRate !== 'N/A'" style="background-color: #DEB4B4; 
                                    display: flex;
                                    height: 50px;
                                    align-items: center; 
                                    justify-content: flex-end;
                                    padding-right: 8px;
                                    font-weight: bold;
                                    color: #D63E4A;">
                                    <span>{{ Number(getActualOilRate) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="height: 150px;" class="oil-prod-text">
                        <h4 style="margin-top: 8px; width: 50px; height: 40px;">
                            <icon class="icon mr-2" :icon="gas()"></icon>
                        </h4>
                        <span class="left-span" />
                        <div class="content">
                            <div class="w-100">
                                <div v-if="getExpectedGasRate !== 'N/A'" style="background-color: #CCFCDC; 
                                    display: flex;
                                    height: 50px;
                                    align-items: center; 
                                    justify-content: flex-end;
                                    padding-right: 8px;
                                    font-weight: bold;
                                    color: green;">
                                    <span>{{ Number(getExpectedGasRate).toFixed(2) }}</span>
                                </div>
                                <div class="mt-1" v-if="getActualGasRate !== 'N/A'" style="background-color: #95F3B2; 
                                    display: flex;
                                    height: 50px;
                                    align-items: center; 
                                    justify-content: flex-end;
                                    padding-right: 8px;
                                    font-weight: bold;
                                    color: green;">
                                    <span>{{ Number(getActualGasRate) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="challenge-container border">
                <h4>Challenge</h4>
                <div class="objective-container-text" style="max-height: 50px; overflow-y: auto; font-size: .92rem; padding-bottom: 0.25rem;">
                    {{ dailyReportsByProject.length &&
                        dailyReportsByProject[dailyReportsByProject.length - 1].dailyChallenge !== '' ?
                        dailyReportsByProject[dailyReportsByProject.length - 1].dailyChallenge : 'N/A' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import project from "@/store/modules/project";
import Doughnut from "./charts/Doughnut.vue";
import { HTTP } from "@/axios_api/http-common";
import IconHelper from '@/mixins/iconHelper';
import ICon from "@/components/cc-icon/icon.vue";

export default {
  mixins: [IconHelper],
  components: {
    'doughnut-chart': Doughnut,
    'icon': ICon,
  },
  data() {
    return {
      selectedStatus: "",
      selectedAsset: "",
      selectedWell: "",
      refreshChart: 0,
      refreshAFEChart: 0,
      refreshOilRateChart: 0,
      refreshGasRateChart: 1000,
      project: null,
      hideRigMove: false,
      statusOptions: [
        { text: "Pending", value: "pending" },
        { text: "Ongoing", value: "ongoing" },
        { text: "Completed", value: "completed" },
        { text: "Suspended", value: "suspended" },
      ],
      sequences: [],
      selectedSequenceId: null,
      filteredProjects: [],
      allProjects: [],
      projects: [],
      assets: [],
      wells: [],
      durationChartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
        cutoutPercentage: 85,
      },
      oilGasRateChartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      companyLogo: null,
      showListOfOperationsModal: false,
      isLoading: true,
      isSequenceLoding: true,
      listOfOperationsfields: [
        { key: 'serial', label: 'S/N' },
        { key: 'asset', label: 'Asset' },
        { key: 'well', label: 'Well' },
        { key: 'status', label: 'Status' },
        { key: 'current_phase', label: 'Current Phase' },
      ],
    };
  },
  methods: {
    toggleSideNav(){
        this.$store.commit('setSideNav')
    },
    updateLeftContentMaxWidth(sidenav) {
    //     .well-info {
    //     padding-top: 8px;
    //     padding-bottom: 8px;
    //     flex: 1 !important;
    //     h5 {
    //         font-size: 0.55rem;
    //     }
    //     p {
    //         font-size: 0.475rem;
    //     }
    // }
      const maxWidth = sidenav ? '260px' : '350px';
      const maxWidth150 = sidenav ? '350px' : '400px';
      const fontSizeH5 = sidenav ? '0.54em' : '0.6rem';
      const fontSizeP = sidenav ? '0.4rem' : '0.5rem';
      document.querySelector('.left-content-end').style.setProperty('--left-content-end-max-width', maxWidth);
      document.querySelector('.left-content-end').style.setProperty('--left-content-end-max-width150', maxWidth150);
      document.querySelector('.well-info').style.setProperty('--well-info-font-size-h5', fontSizeH5);
      document.querySelector('.well-info').style.setProperty('--well-info-font-size-p', fontSizeP);
    },
    // ... other methods ...
    getCurrentPhase(projectId) {
      const reports = this._dailyReportsByProject(projectId);
      if (!reports || reports.length === 0) {
        return 'N/A';
      }

      const lastReport = reports[reports.length - 1];
      if (!lastReport || !lastReport.activityLog || lastReport.activityLog.length === 0) {
        return 'N/A';
      }

      const lastActivity = lastReport.activityLog[lastReport.activityLog.length - 1];
      if (!lastActivity || !lastActivity.activityName) {
        return 'N/A';
      }

      return lastActivity.activityName;
    },
    async loadReports() {
      this.isLoading = true;
      try {
        await Promise.all(
          this.listOfOperations.map((operation) =>
            this.$store.dispatch("DailyReportModule/getReportsForProject", operation.projectId)
          )
        );
      } finally {
        this.isLoading = false;
      }
    },
    _dailyReportsByProject(projectId) {
      return this.$store.getters["DailyReportModule/getReportsForProject"](projectId);
    },
    formatNumber(num) {
      if (num >= 1e6) {
        return (num / 1e6).toFixed(2).replace(/\.00$/, '') + 'B';
      } else if (num >= 1e3) {
        return (num / 1e3).toFixed(2).replace(/\.00$/, '') + 'M';
      } else {
        return (num / 1e3).toFixed(2).replace(/\.00$/, '') + 'M';
      }
    },
    getSelectedSequence() {
      this.selectedSequenceId = this.$store.state.Analytics.selectedSequence;
    },
    sequenceSelectionChanged() { },
    getSequences() {
      this.$store.dispatch('departmentModule/getDepartments');
      let sequences = this.$store.getters["sequencesModule/getSequences"] || [];
      if (sequences.length < 1) {
        this.$store.dispatch("sequencesModule/getAllSequence").then((res) => {
          this.sequences = res.data.data;
        });
      } else {
        this.sequences = sequences;
      }
    },
    getProjects(sequenceId) {
      if (!this.selectedSequenceId) return [];      
      this.$store
        .dispatch("projectModule/getProjectsForSequence", sequenceId)
        .then((res) => {
          this.allProjects = res.data.data;
          return this.allProjects
        })
        .finally(() => {
          this.isSequenceLoding = false;
          this.isLoading = false;
        });
    },
    getProjectNameFromId(id) {
      return this.$store.getters["projectModule/getProjectById"](id).name;
    },
    calculateAfeCummulativeCost() {
      const sortedReport = this.dailyReportsByProject.sort((a, b) => {
        const dateA = new Date(a.reportDate);
        const dateB = new Date(b.reportDate);
        return dateA.getTime() - dateB.getTime();
      });
      const allReportByActivity = sortedReport.flatMap((report) => {
        if (report && report.cost && report.cost.budgetLines && report.cost.budgetLines.length && this.project.costOption === 'LineItem') {
          return report.cost.budgetLines.reduce((a, b) => a + (b['lineValue'] || 0), 0);
        }
        else if (report && report.lumpedCosts && report.lumpedCosts.length && this.project.costOption === 'LumpCost') {
          return report.lumpedCosts.reduce((a, b) => a + (b['lineValue'] || 0), 0);
        }
        else if (report && report.dailyTotalCost && report.dailyTotalCost > 0 && this.project.costOption === 'DailyCost') {
          return report.dailyTotalCost;
        }
        else if (report && report.projectCost && report.projectCost.budgetLines && report.projectCost.budgetLines.length && this.project.costOption === 'ProjectCost') {
          return report.projectCost.budgetLines.reduce((a, b) => a + (b['lineValue'] || 0), 0);
        }
        return [];
      });
      return allReportByActivity.reduce((sum, value) => sum + value, 0);
    },
    computeDuration(start, end) {
      if (start == "" || end == "") return 0
      let startDateMill = (new Date(start)).getTime()
      let endDateMill = (new Date(end)).getTime()
      let diff = endDateMill - startDateMill
      if (diff < 1) return 1
      return Math.round(diff / (1000 * 3600 * 24))
    },
    percentage(a, b) {
      if (a == 0) return 0;
      let q = b / a
      let v = q * 100
      return v
    },
    getTimeDifferenceInHours(startDateTime, endDateTime) {
      let passedStartDate = new Date(Date.parse(startDateTime)).getTime();
      let passedEndDate = new Date(Date.parse(endDateTime)).getTime();
      if (passedEndDate <= passedStartDate) {
        passedEndDate = passedEndDate + (24 * 3600 * 1000);
      }
      return Math.round(Math.abs(passedEndDate - passedStartDate) / (1000 * 3600));
    },
    getDifference(actual, plan) {
      const diff = actual - plan;
      return diff >= 0 ? `+${Number(diff).toFixed(2)}` : `${Number(diff).toFixed(2)}`;
    },
    getDifference2(actual, plan) {
      const diff = actual - plan;
      return diff >= 0 ? Number(diff) : Number(diff);
    },
    getActualDifference(actual, plan) {
      const diff = actual - plan;
      return diff >= 0 ? `+${this.formatNumber(Number(diff))}` : `${this.formatNumber(Number(diff))}`;
    },
    getActualDifference2(actual, plan) {
      const diff = actual - plan;
      return Number(diff);
    },
    durationData() {
      const diff = this.getDifference(this.actualDays, (this.project) ?
        this.computeDuration(this.project.start, this.project.end).toFixed(2) : 0);
      const percDiff = this.getDifference2(this.actualDays, (this.project) ?
        this.computeDuration(this.project.start, this.project.end).toFixed(2) : 0);

      // const percent = `+${Number(this.percentage(this.actualDays, (this.project) ?
      //   this.computeDuration(this.project.start, this.project.end) : 0)).toFixed(2)}%`;
      const percent = percDiff > 0 ? `+${Number(percDiff / ((this.project) ? this.computeDuration(this.project.start, this.project.end).toFixed(2) : 0) * 100).toFixed(2)}%` :
        percDiff === 0 ? '+0%' : `${Number(percDiff / ((this.project) ? this.computeDuration(this.project.start, this.project.end).toFixed(2) : 0) * 100).toFixed(2)}%`;
      return { diff, percent };
    },
    afeUSD() {
      const diff = this.getActualDifference((this.dailyReportsByProject.length ? this.afeCummulativeCost : 0), (this.project ? this.getPlanBudgetForProject : 0));
      const percDiff = this.getActualDifference2((this.dailyReportsByProject.length ? this.afeCummulativeCost : 0), (this.project ? this.getPlanBudgetForProject : 0));

      // const percent = `+${Number(this.percentage((this.dailyReportsByProject.length ? this.afeCummulativeCost : 0), (this.project ? this.getPlanBudgetForProject : 0)).toFixed(2))}%`;
      const plan = (this.project ? this.getPlanBudgetForProject : 0);
      const per = plan === 0 ? 0 : (percDiff / (this.project ? this.getPlanBudgetForProject : 0) * 100);
      const percent = per > 0 ? `+${Number(per).toFixed(2)}%` : per === 0 ? '+0%' : `${Number(per).toFixed(2)}%`;
      return { diff, percent }
    },
    formatDecimals(value) {
      if (!value) return value;
      return Number.isInteger(value) ? value : value.toFixed(2);
    },
  },
  computed: {
    sidenav () {
        return this.$store.getters['getSideNavStatus']
    },
    RigMovePlanDays() {
      const activities = this.project && this.project.activities.length ? this.project.activities.filter(activity => activity.isRigMove) || [] : 0;
      if (activities.length === 0) return 0;
      const days = activities.map(x => this.computeDuration(x.start, x.end));
      return Number(days.reduce((curr, acc) => acc + curr, 0));
    },
    RigMoveAcualDays() {
      if (this.dailyReportsByProject.length === 0) return 0;
      return Number(this.dailyReportsByProject[this.dailyReportsByProject.length - 1].schedule.actualRigMoveDays)
    },
    sequenceOptions() {
      if (this.sequences)
        return this.sequences.map((s) => ({ value: s.id, text: s.name }));
      return [];
    },
    getNPTHoursPercent() {
      if (!this.dailyReportsByProject.length) return 0;

      let allHours = this.dailyReportsByProject.flatMap(report => {
        if (!report.activityLog || !report.activityLog.length) return [];
        return report.activityLog.map(log => (log.hasNpt && log.npt && log.npt.nptHours) ? log.npt.nptHours : 0);
      });
      return allHours.reduce((sum, hours) => sum + hours, 0);
    },
    dailyReportsByProject() {
      return this.$store.getters["DailyReportModule/getReportsForProject"](this.selectedWell);
    },
    actualDays() {
      const diffArr = this.dailyReportsByProject.map(report => this.getTimeDifferenceInHours(report.startTime, report.endTime))
      if (!diffArr.length) return 0
      return (diffArr.reduce((acc, curr) => acc + curr) / 24).toFixed(2)
    },
    actualNPTDays() {
      const diffArr = this.dailyReportsByProject.map(report => this.getTimeDifferenceInHours(report.startTime, report.endTime))
      if (!diffArr.length) return 0
      return (diffArr.reduce((acc, curr) => acc + curr)).toFixed(2)
    },
    getDepartmentOptions() {
      return this.$store.getters['departmentModule/getAllDepartments']
    },
    getPlanBudgetForProject() {
      let totalBudget = 0
      if (this.project.costOption === 'LineItem') {
        if (!this.project.activities.length) return 0
        this.project.activities.forEach((activity) => {
          if (activity.budget) {
            activity.budget.budgetLines.forEach((budgetLine) => {
              totalBudget += budgetLine.lineValue
            })
          }
        });
      }
      else if (this.project.costOption === 'LumpCost') {
        if (!this.project.departmentBudgets || !this.project.departmentBudgets.length) return 0
        this.project.departmentBudgets.forEach(d => {
          totalBudget += d.approvedBudget
        });
      }
      else if (this.project.costOption === 'DailyCost') {
        totalBudget = this.project.approvedAFEBudget;
      }
      else if (this.project.costOption === 'ProjectCost') {
        if(this.project.approvedBudget && this.project.approvedBudget !== null){
          this.project.approvedBudget.budgetLines.forEach((budgetLine) => {
            totalBudget += budgetLine.lineValue
          })
        }
      }
      return totalBudget
    },
    getExpectedOilRate() {
      if (this.project && this.project.well.useTarget) {
        return this.project.well.expectedOilRate;
      }
      else if (this.project && this.project.targets.length) {
        return this.project.targets.filter(target => target.fluidType === 'Oil').map(target => target.expectedRate).reduce((a, b) => a + b, 0);
      }
      return 'N/A';
    },
    getActualOilRate() {
      if (this.dailyReportsByProject && this.dailyReportsByProject[this.dailyReportsByProject.length - 1] && this.dailyReportsByProject[this.dailyReportsByProject.length - 1].targets.length) {
        return this.dailyReportsByProject[this.dailyReportsByProject.length - 1].targets.filter(target => target.fluidType === 'Oil').map(target => target.actualRate).reduce((a, b) => a + b, 0);
      }
      return 'N/A';
    },
    getExpectedGasRate() {
      if (this.project && this.project.well.useTarget) {
        return this.project.well.expectedGasRate;
      }
      else if (this.project && this.project.targets.length) {
        return this.project.targets.filter(target => target.fluidType === 'Gas').map(target => target.expectedRate).reduce((a, b) => a + b, 0);
      }
      return 'N/A';
    },
    getActualGasRate() {
      if (this.dailyReportsByProject && this.dailyReportsByProject[this.dailyReportsByProject.length - 1] && this.dailyReportsByProject[this.dailyReportsByProject.length - 1].targets.length) {
        return this.dailyReportsByProject[this.dailyReportsByProject.length - 1].targets.filter(target => target.fluidType === 'Gas').map(target => target.actualRate).reduce((a, b) => a + b, 0);
      }
      return 'N/A';
    },
    durationChartData() {
      const color = Number(this.actualDays) <= Number((this.project) ?
        this.computeDuration(this.project.start,
          this.project.end) : 0) ? '#118DFF' : '#D63E4A';
      return {
        labels: ["Planned (Days)", "Actual (Days)"],
        datasets: [
          {
            data: [Number(this.project ? this.computeDuration(this.project.start, this.project.end).toFixed(1) : 0), Number(this.actualDays)],
            backgroundColor: ["#A1A5B7", color, "#F1BC00"],
          },
        ],
      }
    },
    afeChartData() {
      const color = Number(this.dailyReportsByProject.length ?
        this.afeCummulativeCost : 0) <= Number(this.project ?
          this.getPlanBudgetForProject : 0) ? '#118DFF' : '#D63E4A';
      return {
        labels: ["Planned AFE ($)", "Actual Spend ($)"],
        datasets: [
          {
            data: [Number(this.project ? this.getPlanBudgetForProject : 0), Number(this.dailyReportsByProject.length ? this.afeCummulativeCost : 0)],
            backgroundColor: ["#A1A5B7", color, "#F1BC00"],
          },
        ],
      }
    },
    afeCummulativeCost() {
      return this.calculateAfeCummulativeCost();
    },
    statusClass() {
      return (status) => {
        if (!status) return;
        const statusColors = {
          ongoing: '#FFC107',
          completed: '#2eaa3e',
          pending: '#DC3545',
          suspended: '#d793d7',
        };

        return {
          background: statusColors[status] || 'Transparent',
          width: 'fit-content',
          paddingBlock: '4px',
          paddingInline: '1.5rem',
          fontWeight: 600,
          marginLeft: 'auto',
          display: 'block',
          color: '#fff',
          marginTop: '2px',
        };
      };
    },
    listOfOperations() {
      return this.allProjects.map(project => {
        return { asset: project.well.leaseId, well: project.name, status: project.projectStatus || 'N/A', current_phase: "Drilling", projectId: project.id}
      })
    }
  },
  watch: {
    sidenav: {
        handler(newVal) {
            this.updateLeftContentMaxWidth(newVal);
        }
    },
    selectedSequenceId: {
      handler(value) {
        this.selectedStatus = "";
        this.selectedAsset = "";
        this.isSequenceLoding = true;        
        this.isLoading = true;
        this.$nextTick(() => {
          this.getProjects(this.selectedSequenceId);
        });
        const savedSequence = localStorage.getItem('selectedSequenceId');
        if (savedSequence && this.selectedSequenceId !== savedSequence) {
            localStorage.removeItem('selectedStatus');
            localStorage.removeItem('selectedAsset');
            localStorage.removeItem('selectedWell');
        }
        if (value) {
          localStorage.setItem('selectedSequenceId', value);
        }
      },
    },
    selectedStatus: {
      handler(value) {
        window.console.log("allProjects", this.allProjects)
        this.selectedAsset = "";
        this.assets = [
            ...new Set(
              this.allProjects
                .filter(
                  (project) => {
                    if (!project.projectStatus) return false;
                    return project.projectStatus.toLowerCase() === this.selectedStatus.toLowerCase();
                  }
                )
                .map((project) => project.well.leaseId)
                .filter(Boolean)
            )
          ];
        window.console.log("assets", this.assets);
        if (value) {
          localStorage.setItem('selectedStatus', value);
        }
      },
    },
    selectedAsset: {
      handler(value) {
        this.selectedWell = "";
        this.wells = this.projects
          .filter((project) => {
            if (project.projectStatus) {
              return project.projectStatus.toLowerCase() === this.selectedStatus.toLowerCase() && project.well.leaseId === this.selectedAsset
            }
            return false
          })
          .map((project) => ({ text: project.well.name, value: project.id }));
        if (value) {
          localStorage.setItem('selectedAsset', value);
        }
      },
      immediate: true,
      deep: true,
    },
    allProjects: {
      handler(value) {
        this.projects = this.allProjects;
        this.filterType = "All";
        
        const selectedStatus = localStorage.getItem('selectedStatus');
        if (value && selectedStatus) {
          this.selectedStatus = selectedStatus;
        }
      },
    },
    selectedWell: {
      handler(value) {
        const project = this.projects.find(
          (project) => project.id == this.selectedWell
        );
        if (project) {
          this.project = project;
        }
        if (this.selectedWell) {
          this.$store.dispatch("DailyReportModule/getReportsForProject", this.selectedWell)
        }
        if (value) {
          localStorage.setItem('selectedWell', value);
        }
      },
    },
    actualDays: {
      handler() {
        this.refreshChart++;
        this.refreshOilRateChart++;
      }
    },
    sequenceOptions: {
        handler(value) {
            const selectedSequenceId = localStorage.getItem('selectedSequenceId');
            if (value.length && !this.selectedSequenceId && selectedSequenceId) {
              const sequenceExist = this.sequenceOptions.find(x => x.value == selectedSequenceId);
              if (sequenceExist) {
                this.selectedSequenceId = selectedSequenceId;
              }
            }
        }
    },
    assets: {
      handler(value) {
          const selectedAsset = localStorage.getItem('selectedAsset');
          if (value.length && !this.selectedAsset && selectedAsset) {
            const assetExist = this.assets.find(x => x == selectedAsset);
            if (assetExist) {
              this.selectedAsset = selectedAsset;
            }
          }
      }, immediate: true
    },
    wells: {
      handler(value) {
          const selectedWell = localStorage.getItem('selectedWell');
          if (value.length && !this.selectedWell && selectedWell) {
            const wellExist = this.wells.find(x => x.value == selectedWell);
            if (wellExist) {
              this.selectedWell = selectedWell;
            }
          }
      }, immediate: true
    },
  },
  mounted() {
    this.updateLeftContentMaxWidth(this.sidenav);
    this.getSequences();
    this.loadReports();
    HTTP.post("appsettings/keys", ["CompanyLogo"])
      .then((res) => {
        this.companyLogo = res.data.data.CompanyLogo;
      })
      .catch((ex) => {
        // Handle error
      });
  },
};
</script>

<style scoped>
.scrollable-dropdown {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-inline: 1.5rem !important;
  position: relative;
}

.custom-select {
  padding-inline: 1.5rem !important;
}

.wrapper {
  width: 100%;
  /* max-width: 1500px; */
  margin-inline: auto;
  position: relative;
  height: 100%;
  display: flex;
  gap: 8px;
}

.border {
  border: 1px solid #ccc;
  border-radius: 6px;
}

.left {
  flex: 0.65;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.right {
  flex: 0.35;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 1rem;
}

.header-element {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 1rem;
}

.header img {
  height: 40px;
}

.header h3 {
  font-size: 1.5rem;
  margin-bottom: 0;
}

.left-content-wrapper {
  display: flex;
  gap: 8px;
  flex: 1;
}

.left-content-wrapper>* {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.objective-container {
  padding: 0.75rem;
  padding-top: 0px;
  padding-bottom: 10px;
}

.objective-container h4 {
  margin-top: 0.5rem;
  margin-bottom: 5px;
  font-size: medium;
  font-weight: 600;
  text-decoration: underline;
}

.objective-container p {
  opacity: 0.7;
}

.well-info {
  display: flex;
  gap: 12px;
  padding: 1rem;
  flex: 1;
}

.well-info>div {
  flex: 1;
  display: grid;
}

.well-info>.left-span {
  width: 3px;
  background-color: rgb(212, 136, 42);
  border-radius: 6px;
}

.well-info>div>div {
  display: flex;
  flex: 1;
  align-items: center;
}

.well-info>div>div h5 {
  font-size: 0.875rem;
}

.well-info>div>div p {
  color: rgb(212, 136, 42);
  font-size: 0.75rem;
}

.current-activity-container {
  padding: 0.75rem;
  padding-top: 0px;
  padding-bottom: 10px;
}

.current-activity-container h4 {
  margin-top: 0.5rem;
  margin-bottom: 5px;
  font-size: medium;
  font-weight: 600;
  text-decoration: underline;
}

.current-activity-container p {
  opacity: 0.7;
}

.left-content-end>div {
  padding: 0.5rem;
}

.duration {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.duration h4 {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: medium;
  font-weight: 600;
  text-decoration: underline;
}

.afe {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.afe h4 {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: medium;
  font-weight: 600;
  text-decoration: underline;
}

.incremental-prod {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  height: 48px;
}

:deep(.custom-control-label) {
    display: inline;
}

.incremental-prod span {
  width: 1.5px;
  background-color: rgb(212, 136, 42);
  display: block;
}

.incremental-prod h4 {
  font-size: medium;
  font-weight: 600;
  margin-bottom: 0;
  align-self: center;
}

.incremental-prod p {
  margin-bottom: 0;
  font-size: 18px;
  align-self: center;
  color: rgb(82, 133, 82);
}

.challenge-container {
  padding: 0.75rem;
  padding-top: 0px;
  padding-bottom: 10px;
}

.challenge-container h4 {
  margin-top: 0.5rem;
  margin-bottom: 5px;
  font-size: medium;
  font-weight: 600;
  text-decoration: underline;
}

.challenge-container p {
  opacity: 0.7;
}

.oil-gap-prod-wrapper {
  flex: 1;
}

.current-activity-container p {
  opacity: 0.7;
}

.dropdowns-container {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dropdowns {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.selected-options {
  padding: 0.75rem;
  max-width: 400px;
  margin-inline: auto;
  width: 100%;
}

.selected-options>div {
  display: flex;
}

.selected-options .asset,
.selected-options .well {
  flex: 1;
  font-weight: 700;
  padding: 0.5rem;
  margin-bottom: 0;
}

.selected-options .asset {
  font-size: 1.5rem;
  border-top: 2px solid rgb(82, 133, 82);
  border-right: 4px solid rgb(212, 136, 42);
}

.selected-options .well {
  border-bottom: 2px solid rgb(136, 57, 57);
}

.selected-options-span {
  width: fit-content;
  padding-block: 4px;
  padding-inline: 1.5rem;
  background-color: rgb(228, 197, 160);
  font-weight: 600;
  margin-left: auto;
  display: block;
  margin-top: 2px;
}

.selected-options-span2 {
  width: fit-content;
  padding-block: 4px;
  padding-inline: 1.5rem;
  background-color: green;
  font-weight: 600;
  margin-left: auto;
  display: block;
  color: #fff;
  margin-top: 2px;
}

.oil-gas-prod-wrapper {
  display: flex;
  flex: 1;
  gap: 8px;
}

.oil-gas-prod-wrapper> :nth-child(1) {
  padding: 0.75rem;
  width: 200px;
}

.oil-gas-prod-wrapper> :nth-child(2) {
  flex: 1;
  padding: 0.875rem;
}

.oil-gas-prod-wrapper .content {
  flex: 1;
  display: flex;
  margin-top: 12px;
  gap: 0.5rem;
}

.oil-gas-prod-wrapper .content h2 {
  font-size: 20px;
  margin-bottom: 0;
}

.oil-gas-prod-wrapper .content p {
  color: rgb(212, 136, 42);
  font-size: 0.875rem;
}

.oil-gas-prod-wrapper h4 {
  margin-bottom: 5px;
  font-size: medium;
  font-weight: 600;
  font-style: italic;
}

.oil-gas-prod-wrapper .left-span {
  width: 3px;
  background-color: rgb(212, 136, 42);
  border-radius: 6px;
}

.oil-gas-prod-charts {
  display: flex;
  flex-direction: column;
  /* max-height: 450px; */
}

.green-zone {
  text-align: center;
  color: #17A939;
}

.red-zone {
  text-align: center;
  color: #D63E4A;
}

.table {
  max-height: 500px !important;
  overflow-y: scroll;
  position: relative;
}

:deep(.custom-control-input) {
  position: relative !important;
}

:deep(.custom-control-label) {
    vertical-align: baseline;
}

@media (max-width: 1540px) {
    .header {
        padding: 0.2rem;
        h3 {
            font-size: 1rem;
        }
        .header-btn {
            font-size: 1rem;
            margin-right: 4px;
        }
        .header-element {
            padding: .2rem;
        }
    }
    .well-info {
        padding-top: 8px;
        padding-bottom: 8px;
        flex: 1 !important;
        h5 {
            font-size: 0.8rem;
        }
        p {
            font-size: 0.7rem;
        }
    }
    .dropdowns-container {
        >div{
            >p {
                margin-top: -8px;
                font-size: 0.8rem !important;
            }
        }
        .report-date {
            font-size: 0.8rem !important;
        }
    }
    .selected-options {
        padding: 0px !important;
        h4, span {
            padding: .3rem .6rem !important;
            font-size: .8rem !important;
        }
    }
    .oil-gas-prod-container {
        h4 {
            font-size: .9rem !important;
        }
        h2 {
            font-size: .8rem !important;
        }
        p {
            font-size: .6rem !important;
        }
        .content div {
            height: auto !important;
        }
    }
    .oil-gas-prod-charts {
        .content div {
            height: 27px !important;
            span {
                font-size: .8rem !important;
            }
        }
    }
}

@media (max-width: 1300px) {
    .left-content-end>div {
        max-width: var(--left-content-end-max-width150, 400px);
        }
        .header {
            padding: 0.2rem;
            h3 {
            font-size: .8rem;
            }
        .header-btn {
            font-size: .8rem;
            margin-right: 4px;
            }
            .header-element {
                padding: .2rem;
                }
    }
    .objective-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .7rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .6rem !important;
            margin-bottom: -6px;
        }
    }
    .current-activity-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .7rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .6rem !important;
            margin-bottom: -6px;
        }
    }
    .challenge-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .7rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .6rem !important;
            margin-bottom: -6px;
        }
    }
    .well-info {
        padding-top: 8px;
        padding-bottom: 8px;
        flex: 1 !important;
        h5 {
            font-size: 0.7rem;
        }
        p {
            font-size: 0.6rem;
        }
    }
    .incremental-prod {
        padding: 3px !important;
        height: 40px !important;
        :deep(.custom-control-label) {
            font-size: 0.6em;
            top: -0.01rem !important;
        }
        :deep(.custom-control-label::before) {
            top: -0.15rem !important;
        }
        .npt-h4{
            font-size: .6rem;
        }
        .npt-p{
            font-size: .6rem;
        }
    }
    .duration {
        font-size: .8rem !important;
        flex: .5 !important;
        .icon-div {
            height: 20px !important;
        }
        .duration-doughnut {
            margin-top: -5px;
            margin-bottom: -8px;
            .doughnut-chart {
                height: 100px !important;
            }
            h1 {
                font-size: 1.2rem;
                line-height: 30px !important;
            }
            h3 {
                font-size: 0.8rem !important;
                line-height: 10px !important;
            }
        }
    }
    .afe {
        font-size: .8rem !important;
        flex: .5 !important;
        .icon-div {
            height: 30px !important;
        }
        .duration-doughnut {
            margin-top: -5px;
            margin-bottom: -8px;
            .doughnut-chart {
                height: 100px !important;
            }
            h1 {
                font-size: 1.2rem;
                line-height: 30px !important;
            }
            h3 {
                font-size: 0.8rem !important;
                line-height: 10px !important;
            }
        }
    }
    .dropdowns-container {
        :deep(.custom-select-sm) {
            padding-top: .1rem !important;
        }
        >div{
            >p {
                margin-top: -9px;
                font-size: 0.6rem !important;
                margin-bottom: 0px !important;
            }
            .select-sequence {
                margin-top: -8px;
                font-size: 0.6rem !important;
                height: 20px;
            }
        }
        .dropdowns div {
            p {
                margin-top: -8px;
                font-size: 0.6rem !important;
            }
            .select-sequence {
                margin-top: -16px;
            }
        }
        .report-date {
            font-size: 0.65rem !important;
            margin-top: -10px;
            margin-bottom: -8px;
        }
    }
    .selected-options {
        padding: 0px !important;
        h4, span {
            padding: .3rem .6rem !important;
            font-size: .8rem !important;
        }
    }
    .oil-gas-prod-wrapper> :nth-child(1) {
        padding: 0.6rem !important;
        padding-top: 0.2rem !important;
    }
    .oil-gas-prod-container {
        max-width: 100px;
        padding: 0px;
        .oil-prod-text {
            height: 80px !important;
        }
        h4 {
            font-size: .7rem !important;
            height: 20px !important;
        }
        h2 {
            font-size: .7rem !important;
        }
        p {
            font-size: .5rem !important;
            margin-bottom: 0rem;
        }
        .content div {
            height: auto !important;
        }
    }
    .oil-gas-prod-charts {
        padding: 0px;
        .oil-prod-text {
            height: 80px !important;
        }
        h4 {
            height: 20px !important;
            .icon {
                margin: 30px !important;
                margin-top: -10px !important;
                margin-left: -3px !important;
            }
        }
        .content div {
            height: 20px !important;
            span {
                font-size: .7rem !important;
            }
        }
    }
}

@media (max-width: 1200px) {
    .wrapper {
        margin-top: -10px !important;
    }
    .left-content-end > div {
        max-width: var(--left-content-end-max-width, 350px); /* Dynamic only here */
    }
    .header {
        padding: 0rem;
        h3 {
            font-size: .7rem;
        }
        .header-btn {
            font-size: .7rem;
            margin-right: 4px;
        }
        .header-element {
            padding: .2rem;
        }
    }
    .objective-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .6rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .55rem !important;
            margin-bottom: -6px;
        }
    }
    .current-activity-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .6rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .55rem !important;
            margin-bottom: -6px;
        }
    }
    .challenge-container {
        h4 {
            margin-top: 2px;
            margin-bottom: 2px;
            font-size: .6rem;
        }
        .objective-container-text {
            height: 40px !important;
            font-size: .55rem !important;
            margin-bottom: -6px;
        }
    }
    .well-info {
        padding-top: 8px;
        padding-bottom: 8px;
        flex: 1 !important;
        h5 {
            font-size: var(--well-info-font-size-h5, 0.6rem);
        }
        p {
            font-size: var(--well-info-font-size-p, 0.5rem);
        }
    }
    .incremental-prod {
        padding: 3px !important;
        height: 40px !important;
        :deep(.custom-control-label) {
            font-size: 0.55em;
            top: -0.01rem !important;
        }
        :deep(.custom-control-label::before) {
            top: -0.15rem !important;
        }
        .npt-btn h4{
            font-size: .55rem;
        }
        .npt-btn p{
            font-size: .55rem;
        }
    }
    .duration {
        font-size: .7rem !important;
        flex: .5 !important;
        .icon-div {
            height: 20px !important;
        }
        .duration-doughnut {
            margin-top: -5px;
            margin-bottom: -8px;
            .doughnut-chart {
                height: 100px !important;
            }
            h1 {
                font-size: 1.2rem;
                line-height: 35px !important;
            }
            h3 {
                font-size: 0.8rem !important;
                line-height: 10px !important;
            }
        }
    }
    .afe {
        font-size: .7rem !important;
        flex: .5 !important;
        .icon-div {
            height: 30px !important;
        }
        .duration-doughnut {
            margin-top: -5px;
            margin-bottom: -8px;
            .doughnut-chart {
                height: 100px !important;
            }
            h1 {
                font-size: 1.2rem;
                line-height: 35px !important;
            }
            h3 {
                font-size: 0.8rem !important;
                line-height: 10px !important;
            }
        }
    }
    .dropdowns-container {
        :deep(.custom-select-sm) {
            padding-top: .1rem !important;
        }
        >div{
            >p {
                margin-top: -9px;
                font-size: 0.55rem !important;
                margin-bottom: 0px !important;
            }
            .select-sequence {
                margin-top: -8px;
                font-size: 0.55rem !important;
                height: 20px;
            }
        }
        .dropdowns div {
            p {
                margin-top: -8px;
                font-size: 0.55rem !important;
            }
            .select-sequence {
                margin-top: -16px;
            }
        }
        .report-date {
            font-size: 0.6rem !important;
            margin-top: -10px;
            margin-bottom: -8px;
        }
    }
    .selected-options {
        margin-top: -3px;
        padding: 0px !important;
        h4, span {
            padding: .2rem .5rem !important;
            font-size: .6rem !important;
        }
    }
    .oil-gas-prod-wrapper> :nth-child(1) {
        padding: 0.5rem !important;
        padding-top: 0.15rem !important;
    }
    .oil-gas-prod-container {
        max-width: 100px;
        padding: 0px;
        .oil-prod-text {
            height: 80px !important;
        }
        h4 {
            font-size: .6rem !important;
            height: 20px !important;
        }
        h2 {
            font-size: .6rem !important;
        }
        p {
            font-size: .5rem !important;
            margin-bottom: 0rem;
        }
        .content div {
            height: auto !important;
        }
    }
    .oil-gas-prod-charts {
        padding: 0px;
        .oil-prod-text {
            height: 80px !important;
        }
        h4 {
            height: 20px !important;
            .icon {
                margin: 30px !important;
                margin-top: -10px !important;
                margin-left: -3px !important;
            }
        }
        .content div {
            height: 20px !important;
            span {
                font-size: .6rem !important;
            }
        }
    }
}


</style>
